import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Crown } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { btnPrimary, card, label } from "@/lib/styles";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const polled = useRef(0);

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("failed"); return; }
    let active = true;
    const poll = async () => {
      if (!active) return;
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") { await refreshUser(); setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("failed"); return; }
      } catch {}
      polled.current += 1;
      if (polled.current >= 8) { setStatus("failed"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [refreshUser]);

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-4">
      <div className={`${card} p-10 max-w-md w-full text-center scanlines`} data-testid="billing-result">
        {status === "checking" && <p className="text-emerald-400 font-mono"><span className="cursor-blink">verifying payment</span></p>}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-400 mb-4" size={48} />
            <span className={label}>// welcome to pro</span>
            <h1 className="mt-2 text-2xl font-black uppercase tracking-tight flex items-center justify-center gap-2"><Crown className="text-yellow-400" /> You're Pro</h1>
            <p className="text-sm text-zinc-400 mt-2">Unlimited mock interviews unlocked. Time to get grilled.</p>
            <button onClick={() => navigate("/curriculum")} className={`${btnPrimary} mt-6`} data-testid="billing-continue">Start interviewing</button>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle className="mx-auto text-red-400 mb-4" size={48} />
            <h1 className="text-2xl font-black uppercase tracking-tight">Payment not confirmed</h1>
            <p className="text-sm text-zinc-400 mt-2">We couldn't confirm your payment. If you were charged it may take a moment.</p>
            <button onClick={() => navigate("/pricing")} className={`${btnPrimary} mt-6`}>Back to pricing</button>
          </>
        )}
      </div>
    </div>
  );
}
